module.exports = __webpack_public_path__ + "media/images/dailySpecialMarker@3x-c269d92e8b7ee9eb549d359ae764930d.png";